import { AxiosRequestConfig } from "axios";
import http from "../base/http.service";
import {
  AnimalCareStandardCreateDto,
  AnimalCareStandardDto,
  AnimalCareStandardUpdateDto,
  ApplicationFormsCreateDto,
  ApplicationFormDto,
  CosmosStandardCreateDto,
  CosmosStandardDto,
  CosmosStandardUpdateDto,
  GotsInputStandardCreateDto,
  GotsInputStandardDto,
  GotsInputStandardUpdateDto,
  VeganStandardCreateDto,
  VeganStandardUpdateDto,
  VeganStandardDto,
  DetergentStandardCreateDto,
  DetergentStandardUpdateDto,
  DetergentStandardDto,
  CreateGeneralStandardDto,
  GeneralStandardDto,
  UpdateGeneralStandardDto,
  CreateTrOrganicStandardDto,
  TrOrganicStandardDto,
  UpdateTrOrganicStandardDto,
  UpdateTROrganikPartialDto,
  CreateNOPStandardDto,
  NOPStandardDto,
  UpdateNOPPartialDto,
  UpdateNOPStandardDto,
  CreateEUStandardDto,
  EUStandardDto,
  UpdateEUPartialDto,
  UpdateEUStandardDto,
  GlobalGAPStandardDto,
  CreateGlobalGAPStandardDto,
  UpdateGlobalGAPStandardDto,
  UpdateGlobalGAPPartialDto,
  GMOFreeStandardDto,
  CreateGMOFreeStandardDto,
  UpdateGMOFreeStandardDto,
  UpdateGMOFreePartialDto,
  SendToApproveDto,
  UpdateTROrganicAppFileDto,
  CreateITUStandardDto,
  UpdateITUStandardDto,
  BaseStandardDto,
  UpdateApplicationFormDto,
  RejectToOfferDto,
  ApproveToOfferDto,
  RejectToOfferByUIDDto,
  SignedToContractDto,
  ApproveToContractDto,
  PaymentReceivedDto,
  GenericInvoiceDto,
  PaymentCompletedDto,
  NewApplicationFormDto,
  SendToOfferDto,
  SendToContractDto,
  ITUStandardDto,
  SendToAprStageDto,
  SummaryApplicationFormDto,
  CompleteAPREvaluationDto,
  GetApplicationHistoryDto,
  UploadOfferDto,
  CreateToContractDto,
  UpdateSignedContractDto,
  RejectSignedOfferDto,
  RejectSignedContractDto,
  HistoricalDocumentDto,
} from "./application.dto";
import { FilteredListDto } from "../base/base.dto";
import { UserDto } from "../users/users.dto";

const services = {
  Create(dto: ApplicationFormsCreateDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<ApplicationFormDto>("ApplicationForms", dto, config);
  },
  NewApplicationForm(dto: NewApplicationFormDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<ApplicationFormDto>("applicationForms/newApplicationForm", dto, config);
  },
  Update(dto: UpdateApplicationFormDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.put<ApplicationFormDto>("ApplicationForms", dto, config);
  },
  GetAll(config?: AxiosRequestConfig<any> | undefined) {
    return http.get<FilteredListDto<SummaryApplicationFormDto>>("ApplicationForms", config);
  },
  GetDraftApplications(config?: AxiosRequestConfig<any> | undefined) {
    return http.get<FilteredListDto<SummaryApplicationFormDto>>(
      "ApplicationForms/getDraftApplications",
      config
    );
  },
  GetMyApplicationWithDocuments(config?: AxiosRequestConfig<any> | undefined) {
    return http.get<FilteredListDto<ApplicationFormDto>>(
      "ApplicationForms/getMyApplicationWithDocuments",
      config
    );
  },
  Get(id: number, config?: AxiosRequestConfig<any> | undefined) {
    return http.get<ApplicationFormDto>(`ApplicationForms/${id}`, config);
  },
  GetByUid(dto: string, config?: AxiosRequestConfig<any> | undefined) {
    return http.get<ApplicationFormDto>(`ApplicationForms/uid=${dto}`, config);
  },
  SendToApprove(dto: SendToApproveDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post("ApplicationForms/approve", dto, config);
  },
  SaveApplicationEvaluation(id: number, config?: AxiosRequestConfig<any> | undefined) {
    return http.post(`ApplicationForms/${id}/saveApplicationEvaluation`, config);
  },
  UploadOffer(dto: UploadOfferDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post(`ApplicationForms/uploadOffer`, dto, config);
  },
  SendToOffer(dto: SendToOfferDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post(`ApplicationForms/sendToOffer`, dto, config);
  },
  SendToContract(dto: SendToContractDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post(`ApplicationForms/sendToContract`, dto, config);
  },
  CreateToContract(dto: CreateToContractDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post(`ApplicationForms/createToContract`, dto, config);
  },
  RequestReviewOffer(id: number, config?: AxiosRequestConfig<any> | undefined) {
    return http.post(`ApplicationForms/${id}/requestReviewToOffer`, config);
  },
  RejectSignedOffer(dto: RejectSignedOfferDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post(`ApplicationForms/rejectApprovedOffer`, dto, config);
  },
  RejectSignedContract(dto: RejectSignedContractDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post(`ApplicationForms/rejectSignedContract`, dto, config);
  },
  PaymentReceived(dto: PaymentReceivedDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post(`ApplicationForms/paymentReceived`, dto, config);
  },
  UploadInvoiceFile(dto: PaymentReceivedDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post(`ApplicationForms/uploadInvoiceFile`, dto, config);
  },
  CreateToProforma(id: number, config?: AxiosRequestConfig<any> | undefined) {
    return http.post(`ApplicationForms/${id}/createToProforma`, config);
  },
  RejectToOffer(dto: RejectToOfferDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post("ApplicationForms/rejectToOffer", dto, config);
  },
  RejectToOfferByUID(dto: RejectToOfferByUIDDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post("ApplicationForms/rejectToOfferByUID", dto, config);
  },
  ApproveToOffer(dto: ApproveToOfferDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post("ApplicationForms/approveToOffer", dto, config);
  },
  SignedToContract(dto: SignedToContractDto[], config?: AxiosRequestConfig<any> | undefined) {
    return http.post("ApplicationForms/signedToContract", dto, config);
  },
  ApproveToContract(dto: ApproveToContractDto[], config?: AxiosRequestConfig<any> | undefined) {
    return http.post("ApplicationForms/approveToContract", dto, config);
  },
  UpdateSignedContract(
    dto: UpdateSignedContractDto[],
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return http.post("ApplicationForms/updateSignedContract", dto, config);
  },
  GetActiveApplications(config?: AxiosRequestConfig<any> | undefined) {
    return http.get<FilteredListDto<SummaryApplicationFormDto>>(
      "ApplicationForms/getActiveApplications",
      config
    );
  },
  GetCompletedApplications(config?: AxiosRequestConfig<any> | undefined) {
    return http.get<FilteredListDto<SummaryApplicationFormDto>>(
      "ApplicationForms/getCompletedApplications",
      config
    );
  },
  GetAllInvoicesByUserID(config?: AxiosRequestConfig<any> | undefined) {
    return http.get<FilteredListDto<GenericInvoiceDto>>(
      "ApplicationForms/getAllInvoicesByUserID",
      config
    );
  },

  PaymentCompleted(dto: PaymentCompletedDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post(`ApplicationForms/paymentCompleted`, dto, config);
  },
  SendToAprStage(dto: SendToAprStageDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post("ApplicationForms/sendToAprStage", dto, config);
  },
  SendToAPRReview(id: number, config?: AxiosRequestConfig<any> | undefined) {
    return http.post(`ApplicationForms/${id}/sendToAPRReview`, config);
  },
  CompleteAPREvaluation(
    dto: CompleteAPREvaluationDto,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return http.post(`ApplicationForms/completeAPREvaluation`, dto, config);
  },
  GetApplicationHistory(applicationID: number, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<GetApplicationHistoryDto[]>(
      `ApplicationForms/getApplicationHistory?applicationID=${applicationID}`,
      config
    );
  },
  GetStandard(dto: number, config?: AxiosRequestConfig<any> | undefined) {
    return http.get<BaseStandardDto>(`BaseStandards/standard/${dto}`, config);
  },
  AddAnimalCareStandard(
    dto: AnimalCareStandardCreateDto,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return http.post<AnimalCareStandardDto>("BaseStandards/AddAnimalcareStandard", dto, config);
  },
  UpdateAnimalCareStandard(
    dto: AnimalCareStandardUpdateDto,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return http.put<AnimalCareStandardDto>("BaseStandards/UpdateAnimalcareStandard", dto, config);
  },
  AddGotsInputStandard(
    dto: GotsInputStandardCreateDto,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return http.post<GotsInputStandardDto>("BaseStandards/AddGOTSInputStandard", dto, config);
  },
  UpdateGotsInputStandard(
    dto: GotsInputStandardUpdateDto,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return http.put<GotsInputStandardDto>("BaseStandards/UpdateGOTSInputStandard", dto, config);
  },
  AddCosmosStandard(dto: CosmosStandardCreateDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<CosmosStandardDto>("BaseStandards/AddCosmosStandard", dto, config);
  },
  UpdateCosmosStandard(dto: CosmosStandardUpdateDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.put<CosmosStandardDto>("BaseStandards/UpdateCosmosStandard", dto, config);
  },
  AddVeganStandard(dto: VeganStandardCreateDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<VeganStandardDto>("BaseStandards/AddVeganStandard", dto, config);
  },
  UpdateVeganStandard(dto: VeganStandardUpdateDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.put<VeganStandardDto>("BaseStandards/UpdateVeganStandard", dto, config);
  },
  AddDetergentStandard(
    dto: DetergentStandardCreateDto,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return http.post<DetergentStandardDto>("BaseStandards/AddDetergentStandard", dto, config);
  },
  UpdateDetergentStandard(
    dto: DetergentStandardUpdateDto,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return http.put<DetergentStandardDto>("BaseStandards/UpdateDetergentStandard", dto, config);
  },
  AddGeneralStandard(dto: CreateGeneralStandardDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<GeneralStandardDto>("BaseStandards/AddGeneralStandard", dto, config);
  },
  UpdateGeneralStandard(
    dto: UpdateGeneralStandardDto,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return http.put<GeneralStandardDto>("BaseStandards/UpdateGeneralStandard", dto, config);
  },

  // Agriculture services
  // TR Organik services
  AddTROrganikStandard(
    dto: CreateTrOrganicStandardDto,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return http.post<TrOrganicStandardDto>("BaseStandards/AddTROrganikStandard", dto, config);
  },
  UpdateTROrganikStandard(
    dto: UpdateTrOrganicStandardDto,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return http.put<TrOrganicStandardDto>("BaseStandards/UpdateTROrganikStandard", dto, config);
  },
  UpdateTROrganikStandardPartial(
    dto: UpdateTROrganikPartialDto,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return http.patch<TrOrganicStandardDto>("BaseStandards/UpdateTROrganikStandard", dto, config);
  },
  UpdateTROrganicApplicationFormFileAsync(
    dto: UpdateTROrganicAppFileDto,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return http.patch("BaseStandards/UpdateTROrganikApplicationForm", dto, config);
  },
  // NOP services
  AddNOPStandard(dto: CreateNOPStandardDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<NOPStandardDto>("BaseStandards/AddNOPStandard", dto, config);
  },
  UpdateNOPStandard(dto: UpdateNOPStandardDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.put<NOPStandardDto>("BaseStandards/UpdateNOPStandard", dto, config);
  },
  UpdateNOPStandardPartial(dto: UpdateNOPPartialDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.patch<NOPStandardDto>("BaseStandards/UpdateNOPStandard", dto, config);
  },
  // EU services
  AddEUStandard(dto: CreateEUStandardDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<EUStandardDto>("BaseStandards/AddEUStandard", dto, config);
  },
  UpdateEUStandard(dto: UpdateEUStandardDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.put<EUStandardDto>("BaseStandards/UpdateEUStandard", dto, config);
  },
  UpdateEUStandardPartial(dto: UpdateEUPartialDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.patch<EUStandardDto>("BaseStandards/UpdateEUStandard", dto, config);
  },
  // GlobalGAP services
  AddGlobalGAPStandard(
    dto: CreateGlobalGAPStandardDto,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return http.post<GlobalGAPStandardDto>("BaseStandards/AddGlobalGAPStandard", dto, config);
  },
  UpdateGlobalGAPStandard(
    dto: UpdateGlobalGAPStandardDto,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return http.put<GlobalGAPStandardDto>("BaseStandards/UpdateGlobalGAPStandard", dto, config);
  },
  UpdateGlobalGAPStandardPartial(
    dto: UpdateGlobalGAPPartialDto,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return http.patch<GlobalGAPStandardDto>("BaseStandards/UpdateGlobalGAPStandard", dto, config);
  },
  // GMO Free services
  AddGMOFreeStandard(dto: CreateGMOFreeStandardDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<GMOFreeStandardDto>("BaseStandards/AddGMOFreeStandard", dto, config);
  },
  UpdateGMOFreeStandard(
    dto: UpdateGMOFreeStandardDto,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return http.put<GMOFreeStandardDto>("BaseStandards/UpdateGMOFreeStandard", dto, config);
  },
  UpdateGMOFreeStandardPartial(
    dto: UpdateGMOFreePartialDto,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return http.patch<GMOFreeStandardDto>("BaseStandards/UpdateGMOFreeStandard", dto, config);
  },
  // ITU services
  AddITUStandard(dto: CreateITUStandardDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<ITUStandardDto>("BaseStandards/AddITUStandard", dto, config);
  },
  UpdateITUStandard(dto: UpdateITUStandardDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.put<ITUStandardDto>("BaseStandards/UpdateITUStandard", dto, config);
  },

  GetHistoricalDocummentsByApplicationId(
    applicationID: number,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return http.get<HistoricalDocumentDto>(
      `ApplicationForms/historical-documents/${applicationID}`,
      config
    );
  },
  SendToCustomerForNonConformityApproval(
    applicationID: number,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return http.post(
      `ApplicationForms/${applicationID}/sendToCustomerForNonConformityApproval`,
      config
    );
  },
  GetEligibleAPROfficers(applicationID: number, config?: AxiosRequestConfig<any> | undefined) {
    return http.get<{
      aprOfficers: UserDto[];
    }>(`ApplicationForms/eligibleAPROfficers/${applicationID}`, config);
  },
};

export default services;
